// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { EntityPropertyIdBuf } from '../entity/entity-property-id-buf.js';


/**
 * Setting to sort a given property in your view mode. Note that the
 * method of sorting non-integer properties is determined by the 
 * client.
 */
export class ViewModeSortBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ViewModeSortBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsViewModeSortBuf(bb:flatbuffers.ByteBuffer, obj?:ViewModeSortBuf):ViewModeSortBuf {
  return (obj || new ViewModeSortBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsViewModeSortBuf(bb:flatbuffers.ByteBuffer, obj?:ViewModeSortBuf):ViewModeSortBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ViewModeSortBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

propertyId(obj?:EntityPropertyIdBuf):EntityPropertyIdBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new EntityPropertyIdBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

descending():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

static startViewModeSortBuf(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addPropertyId(builder:flatbuffers.Builder, propertyIdOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, propertyIdOffset, 0);
}

static addDescending(builder:flatbuffers.Builder, descending:boolean) {
  builder.addFieldInt8(1, +descending, +false);
}

static endViewModeSortBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createViewModeSortBuf(builder:flatbuffers.Builder, propertyIdOffset:flatbuffers.Offset, descending:boolean):flatbuffers.Offset {
  ViewModeSortBuf.startViewModeSortBuf(builder);
  ViewModeSortBuf.addPropertyId(builder, propertyIdOffset);
  ViewModeSortBuf.addDescending(builder, descending);
  return ViewModeSortBuf.endViewModeSortBuf(builder);
}
}
